module.exports = __webpack_public_path__ + "static/media/Peer.662baadb.webp";